// TODO: onBlur instead of onChange for a11y?
/* eslint-disable jsx-a11y/no-onchange */

import { useState } from "react"
import { graphql, withPrefix } from "gatsby"
import { StyledRow, StyledSelectsWrapper, StyledList, StyledLink, StyledJobSection } from "./styled-careers"
import { StyledHeaderSection, StyledColumn } from "../jobs/styled-apply"
import useCareersAPI from "./useCareersAPI"
import { MikanSpan } from "@components/Mikan"
import { FormFieldSelect } from "@fastly/consistently"

const CurrentOpenings = ({ data }) => {
  const DEFAULT_SELECT = data.anyFilters.text

  const { departmentsWithOffers, locations, allDepartments } = useCareersAPI()

  const [departmentSelect, setDepartmentSelect] = useState(DEFAULT_SELECT)
  const [locationSelect, setLocationSelect] = useState(DEFAULT_SELECT)

  const getGroupedSortedJobOffers = (department) => {
    const subDepartmentJobExistsInParent = (childId, parentId) => childId === parentId

    const getAllSubDepartmentJobs = (childId) =>
      allDepartments.reduce((acc, { id, jobs }) => {
        if (subDepartmentJobExistsInParent(childId, id)) {
          const subDeparments = jobs.reduce((acc, job) => [...acc, job], [])
          return [...acc, ...subDeparments]
        }
        return [...acc]
      }, [])

    const deparmentJobsList = department.jobs.reduce((acc, job) => [...acc, job], [])
    const subDepartmentsJobsList = department.childIds.reduce((acc, childId) => {
      const subDepartmentJobs = getAllSubDepartmentJobs(childId)
      return [...acc, ...subDepartmentJobs]
    }, [])

    const groupedJobs = [...deparmentJobsList, ...subDepartmentsJobsList]

    return groupedJobs.sort((a, b) => (a.title > b.title ? 1 : -1))
  }

  const anyLocationExistsInDepartment = (department) => {
    const defaultSelected = locationSelect === DEFAULT_SELECT
    const jobLocationEqualWithSelect = (job) => job.location["name"] === locationSelect
    const departmentLocationExists = department.jobs.some(jobLocationEqualWithSelect)
    const subDepartmentExistsInParent = (childId, id) => childId === id

    const getJobLocationsEqualToSelected = (jobs) => jobs.find(jobLocationEqualWithSelect)
    const getSubDepartmentLocations = (childId) =>
      allDepartments.find(
        (data) => subDepartmentExistsInParent(childId, data.id) && getJobLocationsEqualToSelected(data.jobs)
      )

    const subDepartmentsJobLocations = department.childIds.filter(getSubDepartmentLocations)

    return defaultSelected || departmentLocationExists || subDepartmentsJobLocations.length > 0
  }

  const locationExistsInDepartment = (currentLocation) => {
    const defaultLocation = locationSelect === DEFAULT_SELECT
    return defaultLocation || currentLocation === locationSelect
  }

  const filtersResultNotEmpty = () => {
    const isDefaultSelected = departmentSelect === DEFAULT_SELECT || locationSelect === DEFAULT_SELECT
    const locationEqualWithSelected = (jobs) => jobs.find((job) => job.location["name"] === locationSelect)
    const getCurrentDepartment = departmentsWithOffers.find((department) => department.name === departmentSelect)

    const departmentLocationsExist =
      !isDefaultSelected && getCurrentDepartment.jobs.find((job) => job.location["name"] === locationSelect)
    const getDeparmentLocations = (childId) =>
      allDepartments.find((data) => childId === data.id && locationEqualWithSelected(data.jobs))

    const subDepartmentsLocations = !isDefaultSelected && getCurrentDepartment.childIds.filter(getDeparmentLocations)

    return !isDefaultSelected && !departmentLocationsExist && !subDepartmentsLocations.length > 0
  }

  const showDepartmentJobList = (department) => {
    const deparmentEqualWithSelect = departmentSelect === DEFAULT_SELECT || departmentSelect === department.name
    return deparmentEqualWithSelect && anyLocationExistsInDepartment(department)
  }

  const getRelativeURL = (absolute_url) => {
    const url = new URL(absolute_url)
    const relative = url.toString().substring(url.origin.length)
    return relative
  }
  const department = [
    { value: data.anyFilters.text, display: data.anyFilters.text },
    ...departmentsWithOffers.map((d) => ({
      value: d.name,
      display: d.name,
    })),
  ]

  const loc = [
    { value: data.anyFilters.text, display: data.anyFilters.text },
    ...locations.map((l) => ({
      value: l,
      display: l,
    })),
  ]

  return (
    <>
      <StyledHeaderSection>
        <StyledRow>
          <StyledColumn>
            <h1>
              <MikanSpan text={data.currentOpenings.text} />
            </h1>
            <StyledSelectsWrapper>
              <FormFieldSelect
                label={data.department.text}
                name="department"
                options={department}
                onChange={(event) => setDepartmentSelect(event.target.value)}
              />
              <FormFieldSelect
                label={data.location.text}
                name="location"
                options={loc}
                onChange={(event) => setLocationSelect(event.target.value)}
              />
            </StyledSelectsWrapper>
          </StyledColumn>
        </StyledRow>
      </StyledHeaderSection>
      <StyledRow>
        <StyledJobSection>
          {filtersResultNotEmpty() && (
            <div>
              <MikanSpan text={data.noFilterResults.text} />
            </div>
          )}

          <StyledList id="job-list">
            {departmentsWithOffers.map(
              (department) =>
                showDepartmentJobList(department) && (
                  <div key={department.id} data-testid="department">
                    <h3 data-testid={department.name}>{department.name}</h3>
                    {getGroupedSortedJobOffers(department).map(
                      (job) =>
                        locationExistsInDepartment(job.location["name"]) && (
                          <div key={job.id}>
                            <StyledLink data-testid="job-link" href={withPrefix(getRelativeURL(job.absolute_url))}>
                              {job.title}
                            </StyledLink>
                            <p data-testid="job-location">{job.location["name"]}</p>
                          </div>
                        )
                    )}
                  </div>
                )
            )}
          </StyledList>
        </StyledJobSection>
      </StyledRow>
    </>
  )
}

export default CurrentOpenings

export const query = graphql`
  query ($contentful_id: String!) {
    page: contentfulPage(contentful_id: { eq: $contentful_id }) {
      ...Page
    }
    currentOpenings: contentfulMicrocopy(contentful_id: { eq: "r0PGBpaPnBn0qZRhnZU5E" }) {
      text
    }
    department: contentfulMicrocopy(contentful_id: { eq: "6HZ0WIU8eMhROCiAfELNeo" }) {
      text
    }
    location: contentfulMicrocopy(contentful_id: { eq: "2cLVMPE6cuhEMaDyPcbP63" }) {
      text
    }
    noFilterResults: contentfulMicrocopy(contentful_id: { eq: "20bDLlIqosQid7d6C1xMNm" }) {
      text
    }
    anyFilters: contentfulMicrocopy(contentful_id: { eq: "13L79uguupS7oENtmBYsdD" }) {
      text
    }
    values: contentfulMicrocopySet(contentful_id: { eq: "oyJxwG0pDpbspauL4aJy7" }) {
      ...microcopySet
    }
  }
`

export { Head } from "@components/Head/Head"
